import React, { useEffect, useRef, useState } from "react";
import "../../assets/Banking/SharesCertificates.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";

const SharesCertificates = () => {
  const componentRef = useRef();
  const [company, setCompany] = useState(null);
  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();
  const data = {
    certificate: "",
    noOfShare: "",
    ledger: "",
    noShare: "",
    to: "",
    name: "",
    fName: "",
    occupation: "",
    address: "",
    date: "28/04/1990",
  };
  const generatePDF = async () => {
    const input = componentRef.current;
    if (!input) {
      console.error("❌ componentRef is null — element not found!");
      return;
    }

    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#fff",
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    // for long certificate
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }
    pdf.save("Share_Certificate.pdf");
  };

  // Fetch Profile (runs once)
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // Fetch Company and Nominee
  useEffect(() => {
    const fetchAllData = async () => {
      if (!profile?.superAdminId) return; // Stop if profile not loaded yet

      // Fetch Company
      try {
        const res = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${profile.superAdminId}`
        );
        const companyData = await res.json();

        if (res.ok) {
          // Fix logo URL
          if (companyData.logo) {
            companyData.logoUrl = `https://payyug.in/${companyData.logo.replace(
              /^images\//,
              ""
            )}`;
          }

          setCompany(companyData);
        } else {
          console.error("Company fetch failed:", companyData);
        }
      } catch (err) {
        console.error("Company fetch error:", err);
      }
    };

    fetchAllData();
  }, [profile?.superAdminId]);

  return (
    <div>
      <div className="SharesCertificates-container">
        <div id="page2"></div>
        <div className="SharesCertificates-border" ref={componentRef}>
          <div className="share-certificate-top-section">
            <div className="share-certificate-company-logo">
              <img src={company?.logoUrl} alt="Logo" />
            </div>
            <div className="SharesCertificates-header">
              <h1 className="SharesCertificates-main-title">
                SHARE CERTIFICATE
              </h1>
              <p className="SharesCertificates-subtitle">
                (Incorporated under the Companies Act, 1956)
              </p>
              <hr className="SharesCertificates-title-underline" />
            </div>
            <div className="share-certificate-company-details">
              <h2>{company?.name || "N/A"}</h2>
              <p>
                CIN no: <span>{company?.cin || "N/A"}</span>{" "}
              </p>
              <p>
                Mobile No: <span>{company?.contact || "N/A"}</span>{" "}
              </p>
              <p>
                Email: <span>{company?.email || "N/A"}</span>{" "}
              </p>
              <p>
                Address: <span>{company?.address || "N/A"}</span>{" "}
              </p>
            </div>
          </div>

          {/* --- Top Details Section --- */}
          <div className="SharesCertificates-details-grid top-details">
            <div className="SharesCertificates-detail-item">
              <label>Certificate No. </label>
              <span className="SharesCertificates-fill-line">
                {data.certificate}
              </span>
            </div>
            <div className="SharesCertificates-detail-item">
              <label>Generates Shares</label>
              <span className="SharesCertificates-fill-line">
                {data.noOfShare}
              </span>
            </div>
            {/* <div className="SharesCertificates-detail-item">
              <label>No. of Shares</label>
              <span className="SharesCertificates-fill-line">
                {data.noOfShare}
              </span>
            </div> */}
            {/* <div className="SharesCertificates-detail-item">
            <label>Shares Ledger Folio</label>
            <span className="SharesCertificates-fill-line">{data.ledger}</span>
          </div> */}
          </div>

          <div className="SharesCertificates-info-row">
            <label>Name of Shareholder :</label>
            <span className="SharesCertificates-fill-line long">
              {data.name}
            </span>
          </div>

          <div className="SharesCertificates-details-grid top-details">
            <div className="SharesCertificates-detail-item">
              <label>Adhar Number</label>
              <span className="SharesCertificates-fill-line">
                {data.noOfShare}
              </span>
            </div>
            <div className="SharesCertificates-detail-item">
              <label>Mobile Number</label>
              <span className="SharesCertificates-fill-line">
                {data.noOfShare}
              </span>
            </div>
          </div>
          {/* --- Shares Range --- */}
          {/* <div className="SharesCertificates-detail-item shares-range">
            <label>No. of Shares</label>
            <span className="SharesCertificates-fill-line short">
              {data.noShare}
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <label>from</label>
            <span className="SharesCertificates-fill-line medium"></span>
            <label>to</label>
            <span className="SharesCertificates-fill-line medium">
              {data.to}
            </span>
            <label>both inclusive</label>
            <span className="SharesCertificates-fill-line medium">
              {data.to}
            </span>
          </div> */}

          {/* --- Holder Information --- */}

          <div className="SharesCertificates-holder-info">
            <div className="SharesCertificates-info-row split-row">
              <div className="SharesCertificates-info-item">
                <label>Father / Husband Name</label>
                <span className="SharesCertificates-fill-line extra-long">
                  {data.fName}
                </span>
              </div>
              <div className="SharesCertificates-info-item right-item">
                <label>Occupation</label>
                <span className="SharesCertificates-fill-line short-right">
                  {data.occupation}
                </span>
              </div>
            </div>
            <div className="SharesCertificates-info-row">
              <label>Address</label>
              <span className="SharesCertificates-fill-line long">
                {data.address}
              </span>
            </div>
          </div>

          {/* Shares information */}
          <div className="shares-info-container">
            <table>
              <tr>
                <th>Allot Per Share</th>
                <th>Value Per Share</th>
                <th>From</th>
                <th>To</th>
              </tr>
              <tr>
                <td>12</td>
                <td>12</td>
                <td>12</td>
                <td>12</td>
              </tr>
            </table>
          </div>

          {/* --- Seal and Date Section --- */}
          <div className="SharesCertificates-seal-section">
            <span className="SharesCertificates-seal-placeholder">
              [Company Seal]
            </span>
            <p className="SharesCertificates-given-text">
              Given under the Common Seal of the Company this
            </p>
            <span className="SharesCertificates-fill-line very-short">
              {data.formNo}
            </span>
            <p className="SharesCertificates-day-text">day of</p>
            <span className="SharesCertificates-fill-line short">
              {data.formNo}
            </span>
          </div>

          {/* --- Signatories Section --- */}
          <div className="SharesCertificates-signatories-section">
            <div className="SharesCertificates-signatory-col">
              <span className="SharesCertificates-sign-line"></span>
              <p>Authorised Signatory</p>
            </div>
            <div className="SharesCertificates-signatory-col">
              <span className="SharesCertificates-sign-line"></span>
              <p>Director</p>
            </div>
            <div className="SharesCertificates-signatory-col">
              <span className="SharesCertificates-sign-line"></span>
              <p>Chairmain / Managing Director</p>
            </div>
          </div>

          <hr className="SharesCertificates-section-divider" />

          {/* --- Calls Paid Table --- */}
          <div className="SharesCertificates-calls-paid-section">
            <h3 className="SharesCertificates-calls-title">
              MEMORANDUM OF CALLS PAID
            </h3>
            <table className="SharesCertificates-calls-table">
              <thead>
                <tr>
                  <th>Date </th>
                  <th>Receipt No. </th>
                  <th>Particulars</th>
                  <th>Per Share (₹)</th>
                  <th>Amount (₹)</th>
                  <th>Signature</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="SharesCertificates-data-cell"></td>
                  <td className="SharesCertificates-data-cell"></td>
                  <td className="SharesCertificates-particulars-cell">
                    <p>Application</p>
                    <span className="SharesCertificates-line-item"></span>
                    <p>Allotment</p>
                    <span className="SharesCertificates-line-item"></span>
                    <p>1st Call</p>
                    <span className="SharesCertificates-line-item"></span>
                    <p>2nd Call</p>
                    <span className="SharesCertificates-line-item"></span>
                  </td>
                  <td className="SharesCertificates-data-cell"></td>
                  <td className="SharesCertificates-data-cell"></td>
                  <td className="SharesCertificates-data-cell"></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="SharesCertificates-notes">
            <h1>SHARE CERTIFICATE DECLARATION</h1>
            <p>
              <span> This is to certify that the person(s)</span> named in this
              certificate is/are the registered holder(s) of the
              within-mentioned share(s) bearing the distinctive number(s) herein
              specified in the above-named company, subject to the provisions
              <br /> of the Memorandum and Articles of Association of the
              company. It is further certified that the amount endorsed herein
              has been paid up on each such share as mentioned above.{" "}
            </p>
          </div>

          <table className="SharesCertificates-table">
            <br />
            <tbody>
              <tr>
                <td colSpan={3}>
                  <strong> EQUITY SHARES EACH OF RUPEES :</strong> {data.name}
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <strong>AMOUNT PAID UP PER SHARE REPEES :</strong> {data.age}
                </td>
              </tr>
            </tbody>
          </table>

          <table className="SharesCertificates-tabletwo">
            <br />
            <tbody>
              <tr>
                <td colSpan={3}>
                  <strong>Reg. Folio No. :</strong> {data.name}
                </td>
                <td colSpan={3}>
                  <strong>Certificate No :</strong> {data.age}
                </td>
              </tr>
              <tr>
                <td colSpan={6}>
                  <strong>Name(s) of Holder(s) :</strong> {data.age}
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <strong>No. of Shares Held :</strong> {data.age}
                </td>
                <td colSpan={3}>
                  <strong>Distinctive No.(s) :</strong> {data.age}
                </td>
              </tr>
            </tbody>
          </table>
          <p className="Shares-p">
            Given under the Common Seal of the Company at
            ______________________________________ this ____________
          </p>

          {/* --- Signatories Section --- */}
          <div className="SharesCertificates-signatories1-section">
            <div className="SharesCertificates-signatory1-col">
              <span className="SharesCertificates-sign1-line"></span>
              <p>Chairmain / Managing Director</p>
            </div>
            <div className="SharesCertificates-signatory1-col">
              <span className="SharesCertificates-sign1-line"></span>
              <p>Director</p>
            </div>
            <div className="SharesCertificates-signatory1-col">
              <span className="SharesCertificates-sign1-line"></span>
              <p>Authorised Director</p>
            </div>
          </div>
          <div className="Share-p2">
            <p2>
              No transfer of any of the Shares comprised in this certificate
              will be registered unless accompanied by this Certificate.
            </p2>
          </div>
        </div>
      </div>

      {/* ✅ Print Button */}
      <div className="SharesCertificates-btn-container">
        <button className="SharesCertificates-btn" onClick={generatePDF}>
          Download PDF
        </button>
      </div>
    </div>
  );
};

export default SharesCertificates;
